import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { STATUS } from "../../../Constants";
import { DomainName } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";



// For Get Token Name APi
const getTokenNameEndpoint = (args)=>`${DomainName}/auth/tokenDetails?userAccessToken=${args.userToken}` ; 

export const getTokenNameAPI = createAsyncThunk('auth/accName' , async(args , thunkAPI)=>{

    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getTokenNameEndpoint(args) , {
            headers : {
                token  : args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ; 
    }

})

// For Add User Access Token 
const addAccessTokenEndpoint = ()=>`${DomainName}/auth/userToken` ; 

export const addUserAccessTokenAPI = createAsyncThunk('auth/addTkn' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        await axios.post(addAccessTokenEndpoint() , {
            userAccessToken : args.userToken , 
        } , {
            headers : {
                token : args.token
            }
        })
        return  args.userToken  
    }catch(eror){
        return rejectWithValue(eror) ; 
    }
})

// For Delete Access Token
const deleteAcessTokenEndpoint =(args)=> `${DomainName}/auth/userToken?id=${args.userAccessToken}`; 
export const deleteAccessTokenAPI = createAsyncThunk('auth/delToken' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 
    try{
            await axios.delete(deleteAcessTokenEndpoint(args) ,{
            headers : {
                token : args.token
            }
        })
        return args.userAccessToken
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Get All Access Token 
const getAllAccessTokenEndpoint = (args)=> `${DomainName}/auth/userToken?userId=${args.id}` ; 

export const getAllAccessTokenAPI = createAsyncThunk("auth/allAcces" , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAllAccessTokenEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data?.userAccessToken
    }catch(error){
        return rejectWithValue(error); 
    }
})

// For Change Password
const changePasswordEndPoint = `${DomainName}/auth/changePassword` ; 

export const changePasswordAPI = createAsyncThunk('auth/changepassword' , async (args , thunkAPI)=>{
    const {rejectWithValue } = thunkAPI
    try{
        await axios.patch(changePasswordEndPoint , {
            password : args.oldPassword , 
            newPassword : args.newPassword
        } , {
            headers : {
                token : args.token
            }
        })
        // dispatch(logout()) ;
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Login API
export const loginAPI = createAsyncThunk('auth/login' ,async ({email , password} , thunkAPII)=>{

    const {rejectWithValue}  = thunkAPII
    try{
        const response = await axios.post(`${DomainName}/auth/login` , {
            email,
            password
    })
    return response.data
    }catch(error){
        return rejectWithValue(error)
    }
   
})


// For Initial State
const initialState = {
    Auth :  JSON.parse(localStorage.getItem('ads-auth')) || null  ,
    status : STATUS.IDLE , // IDLE || LOADING || SUCCESS || ERROR  
    activeAccessToken : localStorage.getItem("active-token") ? localStorage.getItem("active-token") :"" , 
    allAccessTokens : [] , 
    accessTokenStatus : STATUS.IDLE ,
    accountName : "" , 
    accountPhoto :"",
    accountNameStatus: STATUS.IDLE ,
    statusChangePassword : STATUS.IDLE , 
    points : 0
}

const AuthSlice = createSlice({
    name : "auth" ,
    initialState , 
    reducers : {
        logout :(state )=>{
            state.Auth = null ;
            localStorage.removeItem('ads-auth');
            localStorage.removeItem('active-token');
            state.status = STATUS.IDLE  ; 
            state.activeAccessToken = ""
        } , 
        chooseActiveToken : (state , action)=>{
            state.activeAccessToken = action.payload ; 
            localStorage.setItem("active-token" , action.payload)
        }
    } ,
    extraReducers : (builder)=>{
        builder
        // For Login
        .addCase(loginAPI.fulfilled , (state , action)=>{
            toast.success("Login Successfully")
            state.Auth = action.payload ; 
            localStorage.setItem('ads-auth' , JSON.stringify(action.payload))
            state.points = action.payload?.Payload?.points ; 
        })
        .addCase(loginAPI.pending , (state )=>{
            state.status = STATUS.LOADDING ; 
        })
        .addCase(loginAPI.rejected , (state , action )=>{
            toast.error(action.payload?.response?.data?.message) ; 
            state.status = STATUS.ERROR ; 
        })

        // For Change Password
        .addCase(changePasswordAPI.fulfilled , (state)=>{
            state.statusChangePassword = STATUS.SUCCESS ;
            toast.success("Password Changed Successfully")
        })
        .addCase(changePasswordAPI.rejected , ()=>{
            toast.error("Something Error Please Try Again")
        })
        
        // For Get All Access Token API
        .addCase(getAllAccessTokenAPI.fulfilled , (state , action)=>{
            state.allAccessTokens = action.payload;
            state.accessTokenStatus = STATUS.SUCCESS ; 
        })
        .addCase(getAllAccessTokenAPI.pending , (state , action)=>{
            state.accessTokenStatus = STATUS.LOADDING ; 
        })
        .addCase(getAllAccessTokenAPI.rejected , (state , action)=>{
            state.allAccessTokens = STATUS.ERROR ; 
            toast.error("Something error please login again")
        })

        // For Delete User Access Token
        .addCase(deleteAccessTokenAPI.fulfilled , (state ,action)=>{
            state.allAccessTokens =  state.allAccessTokens.filter((item)=>item !== action.payload)
            toast.success("Token Removed Successfully")
        })
        .addCase(deleteAccessTokenAPI.rejected , (state ,action)=>{
            toast.error('something error please login again')
        })
        
        // For Add UserAccess Token
        .addCase(addUserAccessTokenAPI.fulfilled , (state , action)=>{
            // if( !state.allAccessTokens.includes(action.payload)){
            //     state.allAccessTokens.push(action.payload) ; 
            //     toast.success("Token added successfully") ; 
            // }else{
            //     toast.info("Access Token Aready exist")
            // }

            state.allAccessTokens.push(action.payload) ; 

            
        })
        .addCase(addUserAccessTokenAPI.rejected , ( )=>{
            toast.error("Something error please try again ")
        })

        // For Get Account Name
        .addCase(getTokenNameAPI.fulfilled , (state , action)=>{
            state.accountName = action.payload?.data?.name ;
            state.accountPhoto = action.payload?.data?.picture?.data?.url ;
            state.accountNameStatus = STATUS.SUCCESS ; 
        })
        .addCase(getTokenNameAPI.pending , (state , action)=>{
            state.accountName = action.payload?.data?.name ; 
            state.accountNameStatus = STATUS.LOADDING ; 
        })
        .addCase(getTokenNameAPI.rejected , (state , action)=>{
            state.accountNameStatus = STATUS.ERROR ; 
            state.accountPhoto = "" ;
            toast.error("Something error with token ")
        })
    }
})

export default AuthSlice.reducer ;


export const getToken = state => state.AuthSlice.Auth?.token ;

export const getDataUser = state => state.AuthSlice.Auth ; 

export const getAuthData = state => state.AuthSlice ; 

export const getActiveToken = state => state.AuthSlice?.activeAccessToken ; 

export const {logout} = AuthSlice.actions;

export const getRole = state => state.AuthSlice.Auth?.Payload?.role ; 

export const getId = state => state.AuthSlice.Auth?.Payload?.userId ; 

export const getUsername = state => state.AuthSlice.Auth?.Payload?.username ; 


export const getStateusChangePassword = state => state.AuthSlice.statusChangePassword ; 

export const getPoints = state => state.AuthSlice.points ; 

export const getTokenName = state => state.AuthSlice.accountName; 

export const getTokenPhoto = state => state.AuthSlice.accountPhoto

export const getTokenNameStatus = state => state.AuthSlice.accountNameStatus ;



export const {chooseActiveToken} = AuthSlice.actions ; 

export const getAllTokens = (state)=> state.AuthSlice.allAccessTokens